declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveIvfCycleInseminationLogRequest, SaveIvfCycleInseminationInfoRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgbSearchProviderModal } from './searchprovider.modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'ngbeditinsemi',
    templateUrl: './editinsemi.modal.html',
    styleUrls: ['./editinsemi.modal.scss']
})

export class NgbEditInsemiModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;
    @Input() ActorCode;
    @Input() CycleCode: number;
    @Input() IsShowDetail: boolean = false;
    @Input() Mode: string;
    @Input() ServiceCode: number;
    searchTitle: string;
    public ApiResData: ApiResponseModel;
    public maxDate: NgbDateStruct;
    public minDate: NgbDateStruct;
    public ProviderName: string;
    public ProviderCode: number;
    public ProviderNumber: number;
    public ProviderName2: string;
    public ProviderCode2: number;
    public ProviderNumber2: number;
    public Displaynew: boolean = false;
    public Displayold: boolean = true;
    public isRequesting: boolean = false;
    public ShowService: boolean = true;
    CurrentSaveIvfCycleInseminationInfoRequest: SaveIvfCycleInseminationInfoRequest;
    @Input() CurrentEditIvfCycleInseminationInfoRequest: SaveIvfCycleInseminationInfoRequest;

    constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private spinner: NgxSpinnerService,
        private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
        private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
        private tosterservice: NGXToastrService) { }
    ngOnInit() {
        //this.CurrentActorAddEmergencyInfoRequest = new SaveEmergencyContactInfoRequest();
        //this.CurrentActorAddEmergencyInfoRequest.ConditionalOperator = 10;
        //this.CurrentActorAddEmergencyInfoRequest.ActorCode = this.ActorCode;
        //this.CurrentActorAddEmergencyInfoRequest.EmergencyContactCode = 0;
        //this.CurrentActorAddEmergencyInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.ShowService = false;
        // alert(this.CycleCode);
        this.CurrentSaveIvfCycleInseminationInfoRequest = new SaveIvfCycleInseminationInfoRequest();
        this.CurrentSaveIvfCycleInseminationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    }


    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }
    DoctorSelection() {
        const modalRef = this.modalService.open(NgbSearchProviderModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.IsShowDoctor = true;
        modalRef.componentInstance.DoctorType = 'All';
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.ProviderName = receivedEntry.make;
            this.ProviderCode = receivedEntry.value;
            this.ProviderNumber = receivedEntry.number;
            //alert(this.ProviderName);
        })
    }
    DoctorSelection2() {
        this.Displaynew = true;
        this.Displayold = false;
        const modalRef = this.modalService.open(NgbSearchProviderModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.IsShowDoctor = true;
        modalRef.componentInstance.DoctorType = 'All';
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.ProviderName2 = receivedEntry.make;
            this.ProviderCode2 = receivedEntry.value;
            this.ProviderNumber2 = receivedEntry.number;
            this.CurrentEditIvfCycleInseminationInfoRequest.PrescribedBy = this.ProviderCode2;
            this.CurrentEditIvfCycleInseminationInfoRequest.PrescribedByName = this.ProviderName2;

            //alert(this.ProviderName);
        })
    }

    onSubmit() {
        this.spinner.show();
        this.CurrentSaveIvfCycleInseminationInfoRequest.CycleCode = this.CycleCode;
        //this.CurrentSaveIvfCycleInseminationInfoRequest.PrescribedBy = this.ProviderCode;
        //this.CurrentSaveIvfCycleInseminationInfoRequest.PrescribedByName = this.ProviderName;
        this.CurrentSaveIvfCycleInseminationInfoRequest.ConditionalOperator = 10;
        this.CurrentSaveIvfCycleInseminationInfoRequest.InseminationCode = 0;
        this.actorservice.SaveIvfCycleInseminationInfo(this.CurrentSaveIvfCycleInseminationInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        this.activeModal.close();
                        //this.clearData();
                        // this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );


    }

    onSubmitEdit() {
        this.spinner.show();
        // this.CurrentEditIvfCycleInseminationInfoRequest.CycleCode = this.CycleCode;


        //this.CurrentEditIvfCycleInseminationInfoRequest.PrescribedBy = this.ProviderCode;
        //this.CurrentEditIvfCycleInseminationInfoRequest.PrescribedByName = this.ProviderName;
        this.CurrentEditIvfCycleInseminationInfoRequest.ConditionalOperator = 20;
        //this.CurrentSaveIvfCycleInseminationInfoRequest.PrescribedBy = this.ProviderCode2;
        //this.CurrentEditIvfCycleInseminationInfoRequest.InseminationCode = 0;

        this.actorservice.SaveIvfCycleInseminationInfo(this.CurrentEditIvfCycleInseminationInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        this.activeModal.close();
                        //this.clearData();
                        // this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );


    }

    onAssignedToActorCodeEmbryologist2(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveIvfCycleInseminationInfoRequest.PrescribedBy = event;
            this.CurrentSaveIvfCycleInseminationInfoRequest.PrescribedByName = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    onAssignedToActorCodeEmbryologist3(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentEditIvfCycleInseminationInfoRequest.PrescribedBy = event;
            this.CurrentEditIvfCycleInseminationInfoRequest.PrescribedByName = event;
            // console.log('event--_>' + event);
            //   }
        }

    }

}
